import { createAction, handleActions } from "redux-actions";
import { REQUEST_ARTIST_TRACKS, RECEIVE_ARTIST_TRACKS } from "../types";

const defaultState = {};

export const requestArtistTracks = createAction(REQUEST_ARTIST_TRACKS, (id) => ({
    id
}));

export const recieveArtistTracks = createAction(RECEIVE_ARTIST_TRACKS, (data, id) => ({
    data,
    id
}));

const artistName = handleActions(
    {
        [requestArtistTracks]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: { isLoading: true, data: [] }
            };
        },
        [recieveArtistTracks]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: { isLoading: false, data: action.payload.data }
            };
        }
    },
    defaultState
);

export default artistName;
